export const startCase = (str: string): string =>
  str.length > 1 ? str[0].toUpperCase() + str.slice(1) : '';

export const lowerStartCase = (str: string): string =>
  str.length > 1 ? str[0].toLowerCase() + str.slice(1) : '';
